<template>
  <div id="introduction">
    <div class="zy_constr">
      <div class="introduction-card_wap" v-if="isMobile">
        <router-link class="zy_about_link" v-for="item in ABOUT" :key="item.name" :to="item.href">{{
          item.name
        }}</router-link>
      </div>
      <div v-else class="introduction-card">
        <div class="introduction-card__item" v-for="item in ABOUT" :key="item.name">
          <div class="introduction-title">
            <span class="introduction-title__icon" :style="{ backgroundImage: `url(${item.icon})` }"></span
            >{{ item.name }}
          </div>
          <div class="introduction-card__detail">
            <template v-for="subItem in item.detail">
              <div v-if="subItem.title" class="introduction-card__name" :key="subItem.title">
                {{ subItem.title }}
              </div>
              <div v-for="text in subItem.list" class="introduction-card__text" :key="text">
                {{ text }}
              </div>
            </template>
            <div class="introduction-card__text">...</div>
            <Link :href="item.href" class="introduction-link" />
          </div>
        </div>
      </div>
      <Advantage v-if="isMobile"></Advantage>
      <template v-else>
        <div class="introduction-title">
          <span
            class="introduction-title__icon"
            :style="{
              backgroundImage:
                'url(https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/25ecaa8d-ad3a-404a-9285-d38ad222d7fb.png)'
            }"
          ></span
          >业务优势
        </div>
        <div class="introduction-advantage">
          <Tabs :tabs="tabs" :currentTab="currentTab" @onClick="handleClick" />
          <div v-if="currentVisible" class="introduction-advantage__content introduction-advantage__content--current">
            {{ currentAdvantage.desc }}
          </div>
          <div v-if="prevVisible" class="introduction-advantage__content introduction-advantage__content--prev">
            {{ prevAdvantage.desc }}
          </div>
          <img
            v-if="prevVisible"
            class="introduction-advantage__img introduction-advantage__img--prev"
            :src="prevAdvantage.bg"
            alt=""
          />
          <img
            v-if="currentVisible"
            class="introduction-advantage__img introduction-advantage__img--current"
            :src="currentAdvantage.bg"
            alt=""
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Tabs from 'vue-tabs-with-active-line';
import { ABOUT, ADVANTAGE } from '@/config';
import { isMobile } from '@/utils/utils';
import Advantage from '@/views/About/components/Advantage.vue';
import Link from '@/components/Link';

export default {
  name: 'Introduction',
  components: {
    Advantage,
    Tabs,
    Link
  },
  data: function () {
    return {
      ABOUT,
      ADVANTAGE,
      isMobile: isMobile(),
      tabs: ADVANTAGE.map(item => ({
        title: item.name,
        value: item.id
      })),
      currentTab: ADVANTAGE[0].id,
      currentVisible: true,
      prevVisible: false,
      prevAdvantage: null
    };
  },
  computed: {
    currentAdvantage() {
      return ADVANTAGE.find(item => item.id === this.currentTab);
    }
  },
  methods: {
    handleClick(value) {
      this.currentVisible = false;

      this.$nextTick(() => {
        this.prevAdvantage = { ...this.currentAdvantage };
        this.currentTab = value;
        this.currentVisible = true;
        this.prevVisible = true;
      });

      setTimeout(() => {
        this.prevVisible = false;
      }, 300);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
@import '@/styles/tabs.scss';

.introduction-title {
  font-size: 24px;
  color: #000;
  line-height: 36px;
  height: 36px;
  font-weight: 500;
  &__icon {
    width: 28px;
    height: 28px;
    background-size: 100%;
    display: inline-block;
    margin-right: 8px;
    position: relative;
    top: 5px;
  }
}

.introduction-card {
  padding-bottom: 48px;
  display: flex;
}

.introduction-card__item {
  width: 376px;
  margin-left: 16px;
  &:first-child {
    margin-left: 0;
  }
}

.introduction-card__detail {
  height: 180px;
  box-sizing: border-box;
  margin-top: 16px;
  border-radius: 16px;
  background: #f8f8fa;
  padding: 24px 20px;
  font-size: 14px;
  line-height: 20px;
  position: relative;
  .div:first-child {
    margin-top: 0;
  }
}

.introduction-card__name {
  font-weight: 500;
  color: #000;
  margin-top: 8px;
  &:first-child {
    margin-top: 0;
  }
}

.introduction-card__text {
  color: rgba(0, 0, 0, 0.85);
  margin-top: 8px;
  &:first-child {
    margin-top: 0;
  }
}

.introduction-link {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%) scale(1.33);
  background-size: 100%;
}

.introduction-advantage {
  margin-top: 16px;
  height: 240px;
  position: relative;
  border-radius: 16px 0px 0px 16px;
  background: linear-gradient(90deg, #f8f8fa 0%, rgba(248, 248, 250, 0.5) 14.74%, rgba(248, 248, 250, 0.5) 100%);
}

.introduction-advantage__content {
  position: absolute;
  left: 20px;
  top: 74px;
  width: 820px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 25px;
  &--current {
    animation: textAppear 0.3s ease-in-out;
  }
  &--prev {
    animation: elementExit 0.3s ease-in-out;
  }
}

.introduction-advantage__img {
  position: absolute;
  right: 0;
  top: 0;
  width: 332px;
  height: 240px;
  &--current {
    animation: imgAppear 0.3s ease-in-out;
  }
  &--prev {
    animation: elementExit 0.3s ease-in-out;
  }
}

.introduction-card_wap {
  justify-content: center;
  text-align: center;
  margin-bottom: rem(72);

  .zy_about_link {
    color: #000;
    font-size: rem(42);
    font-weight: 500;
    padding-right: rem(48);
    padding-left: rem(36);
    margin-right: rem(36);
    background: url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/9ff538b7-b98b-42c9-bb9b-d7e9758589ed.png')
      no-repeat right center;
    background-size: rem(36);
    position: relative;
    &:after {
      // 灰色竖线，长度为10
      content: '';
      display: block;
      width: 1px;
      height: rem(30);
      background: rgba(0, 0, 0, 0.1);
      position: absolute;
      top: rem(10);
      left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    &:first-child {
      padding-left: 0;
      &:after {
        display: none;
      }
    }
  }
}

@keyframes textAppear {
  0% {
    opacity: 0;
    transform: translate(0, 24px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes imgAppear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes elementExit {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

::v-deep .tabs {
  position: absolute;
  left: 20px;
  top: 24px;
}
</style>
